import Loader from "./Loader";
import Taptop from "./TapTop";
import Header from "./Header";
import Sidebar from "./Sidebar";
import React, { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";
import BookingProvider from "../_helper/Booking/BookingProvider";
import SharedDataProvider from "../_helper/SharedData/SharedDataProvider";
import ApiLoader from "./ApiLoader";
import { TariffSearchProvider } from "../_helper/TariffSearchContext/TariffSeachContext";
const AppLayout = ({ children, classNames, ...rest }) => {
  return (
    <Fragment>
      <Loader />
      <SharedDataProvider>
      <TariffSearchProvider>
      <ApiLoader/>
      <Taptop />
      <div
        className={`page-wrapper compact-wrapper`}
        id="pageWrapper"
      >
       
          <BookingProvider>
            <Header />
            <div className="page-body-wrapper">
              <Sidebar />
              <div className="page-body">
                <div>
                  <Outlet />
                </div>
              </div>
            </div>
          </BookingProvider>
        
      </div>
      </TariffSearchProvider> 
      </SharedDataProvider>
      <ToastContainer />
    </Fragment>
  );
};
export default AppLayout;
